import React from "react";
import { StarFill, BoxArrowUpRight } from "react-bootstrap-icons";
import "./ourservices.scss";

function GoogleReviews() {
  return (
    <section className="section google-review-section">
      <div className="container google-review-card">

        <div className="google-mark">
          G
        </div>

        <div className="google-review-content">
          <span className="eyebrow">Google Reviews</span>

          <h2>See why clients choose Uiplus Technologies Private Limited</h2>

          <div className="google-rating">
            <strong>Client Experiences</strong>

            <div className="stars">
              {[1, 2, 3, 4, 5].map((item) => (
                <StarFill key={item} className="star-icon" />
              ))}
            </div>
          </div>

          <p>
            Read customer feedback, check our location, or share your experience on Google.
          </p>
        </div>

        <a
          className="btn btn-primary"
          href="https://www.google.com/search?q=Uiplus+Technologies+Private+Limited+reviews"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Google Reviews
          <BoxArrowUpRight className="ms-2" />
        </a>

      </div>
    </section>
  );
}

export default GoogleReviews;
